module.exports = __webpack_public_path__ + "img/arrow_back_red.a5b08810.svg";